import { Stack, StackProps } from '@mui/material';

type Props = StackProps;

export function Field({ ...props }: Props) {
  return <Stack spacing="6px" direction="column" {...props} />;
}
